import { render } from "./UpgradeRecords.vue?vue&type=template&id=d2eb79a4&scoped=true"
import script from "./UpgradeRecords.vue?vue&type=script&lang=js"
export * from "./UpgradeRecords.vue?vue&type=script&lang=js"

import "./UpgradeRecords.vue?vue&type=style&index=0&id=d2eb79a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2eb79a4"],['__file',"src/views/HistoricalData/UpgradeRecords/UpgradeRecords.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d2eb79a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d2eb79a4', __exports__)) {
    api.reload('d2eb79a4', __exports__)
  }
  
  module.hot.accept("./UpgradeRecords.vue?vue&type=template&id=d2eb79a4&scoped=true", () => {
    api.rerender('d2eb79a4', render)
  })

}


export default __exports__